import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/telefone";

/**
 * Classe de gerenciamento de chamadas da API do Telefone
 *
 * @class
 */
export default class TelefoneApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe TelefoneApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
   * @returns Lista de telefone por paciente
   */
    listar(codPaciente: number) {

        return this.api<ApplicationModule[]>(`${controller}/listar`, {
            method: "GET",
            params: { codPaciente }
        });
    }

}